import createVueApp from '@phoenix/createVueApp';
import ProductSlider from '@maison/components/ProductSlider.vue';

document.querySelectorAll('.phoenix-product-slider').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('ProductSlider', ProductSlider);
  app.mount(el);
});
